import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import SearchComponent from '@components/Default/Search/SearchComponent';
import IProcess from '@components/FormFlow/Interfaces/Process';
import PageWithoutTitle from '@components/PageWithoutTitle';
import SelectableDataComponent from '@components/SelectableDataComponent';
import IPagination from '@interfaces/IPagination';
import IUnit from '@interfaces/IUnit';
import UnitService from '@services/Unit';
import UserService from '@services/UserService';
import { Routes } from '@src/helpers/_routes';
import NotificationComponent from '@src/helpers/_showNotifications';
import ProcessRequestsInterceptor from '@src/helpers/interceptors/ProcessRequestInterceptor';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Button, Col, Input, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import AWS, { S3 } from 'aws-sdk';
import * as React from 'react';
import { Redirect } from 'react-router-dom';

import Table from '../components/TableComponent';
import { LocalStorageKeys } from './App';
import LiteOnboarding from './LiteOnboarding';

export interface IFormflowContainerProps {
}

export interface IFormflowContainerState {
  isLoading: boolean;
  search: string;
  tableData: IProcess[],
  filteredTableData: IProcess[],
  offset?: string,
  loadingMoreFormflows?: boolean,
  loadingRequest?: boolean,
  serverResponse: any;
  openFormflowRegister?: string;

  unitsData: IUnit[],
  selectedProcessId?: any;
  showUnitSelectModal: boolean;
  selectedProcessObject?: IProcess;
  unitsAlreadySaved: any[];
  actualUnit?: IUnit;

  toggleTranslate: boolean;
  dataTranslate: any;
  dataPT: any;
  dataEn: any;
  dataEs: any;
  langUpdate?: any;
  idProcessTranslate: string;
  loadLangs: boolean;
  saveLoadLangs: boolean;
  saveLang?: string;
  hasSeenOnboarding: boolean;

  isDuplicating?: boolean;
}

const tableColumns = [{
  title: 'table.formflow.name',
  dataIndex: 'name',
  key: 'name',
  class: 'name',
  width: '30%'
}, {
  title: 'table.formflow.version',
  dataIndex: 'version',
  key: 'version',
}, {
  title: 'table.products.createdAt',
  dataIndex: 'createdAt',
  key: 'createdAt',
}, {
  title: 'table.actions',
  dataIndex: 'action',
  key: 'action',
  width: '30%'
}];

const _formflowService: ProcessRequestsInterceptor = new ProcessRequestsInterceptor();
const _unitsService: UnitService = new UnitService();

export default class FormflowContainer extends React.Component<IFormflowContainerProps, IFormflowContainerState> {

  private idUnit: string;
  private currentPillar: string;
  private _userService: UserService;
  private _processService: ProcessRequestsInterceptor

  constructor(props: IFormflowContainerProps) {
    super(props);
    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))
    this._userService = new UserService();
    this.currentPillar = String(localStorage.getItem(LocalStorageKeys.PILLAR))
    this._processService = new ProcessRequestsInterceptor()

    this.state = {
      isLoading: true,
      loadingRequest: false,
      search: '',
      tableData: [],
      filteredTableData: [],
      serverResponse: undefined,
      openFormflowRegister: undefined,
      showUnitSelectModal: false,
      unitsData: [],
      selectedProcessObject: undefined,
      unitsAlreadySaved: [],
      langUpdate: undefined,

      toggleTranslate: false,
      dataTranslate: [],
      dataPT: [],
      dataEn: [],
      dataEs: [],
      idProcessTranslate: '',
      loadLangs: false,
      saveLoadLangs: false,
      saveLang: undefined,
      hasSeenOnboarding: false,

      isDuplicating: false
    }

    this.getFormflows = this.getFormflows.bind(this);
    this.registerFormflow = this.registerFormflow.bind(this);
    this.searchFormflows = this.searchFormflows.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.deleteFormflow = this.deleteFormflow.bind(this);
    this.loadMoreFormflows = this.loadMoreFormflows.bind(this);
    this.onEditFormflow = this.onEditFormflow.bind(this);
    this.getUnits = this.getUnits.bind(this);
    this.toggleUnitSelectModal = this.toggleUnitSelectModal.bind(this);
    this.onRemoveUnit = this.onRemoveUnit.bind(this);
    this.onAddUnit = this.onAddUnit.bind(this);
    this.unitAdded = this.unitAdded.bind(this);
    this.unitRemoved = this.unitRemoved.bind(this);
    this.onDuplicate = this.onDuplicate.bind(this)

    this.setUnit(this.idUnit || '');

  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.getUnits(true);
    this.onboardingSawValidator()
  }

  onboardingSawValidator = () => {

    if (localStorage.getItem('hasSeenOnboarding')) {
      this.setState({ hasSeenOnboarding: true })
    }
  }

  setUnit(unitId: string) {
    this.idUnit = unitId;
  }

  registerFormflow() {
    this.setState({ openFormflowRegister: '' });
  }

  async getUnits(showLoading?: boolean) {
    if (showLoading != undefined) { this.setState({ isLoading: showLoading }) };

    try {
      const data: IUnit[] = await _unitsService.listAll(['id', 'name']);

      let newUnitsData: any[] = [];
      let actualUnitObject: any;

      if (data && data.length > 0) {
        newUnitsData = data.filter((item: IUnit) => item.id != this.idUnit);

        actualUnitObject = data.find((unit: IUnit) => unit.id === this.idUnit);
      }

      this.setState({ unitsData: newUnitsData, actualUnit: actualUnitObject });
    } catch (error) {
      console.warn(error);
      this.setState({
      });
    }
    this.getFormflows(true, true);
  };


  async getFormflows(reset: boolean, showLoading?: boolean) {
    if (showLoading != undefined) { this.setState({ isLoading: showLoading }) };

    if (reset) {
      this.setState({
        offset: undefined
      });
    }
    try {
      console.log("ThisIDUNIT === ", this.idUnit);
      const response: IPagination<IProcess> = await _formflowService.paging({
        unit: this.idUnit,
        to: undefined,
        from: undefined,
        search: this.state.search,
        limit: 10,
        offset: this.state.offset
      });

      let dataTableCreate: any = [];

      if (!reset) {
        dataTableCreate = this.state.tableData || [];
      }

      dataTableCreate = dataTableCreate.concat(this.formatDataToTable(response.items));
      this.setState({ tableData: dataTableCreate, isLoading: false, offset: response.offset, loadingMoreFormflows: false });
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l('common.error'), e);
      this.setState({ isLoading: false, loadingMoreFormflows: false });
    }
  }

  /// Get the data from api and format to fit correctly in the table
  formatDataToTable(data: IProcess[]) {
    if (data === undefined || data.length === 0) { return [] };

    const formatedData: any = [];

    data.map((formflow: IProcess, i: number) => {
      const linkUnitInfo = (
        <Col >
          <a href="#" onClick={() => this.toggleUnitSelectModal(formflow.id || '')}>{I18n.l('table.formflow.linkUnits')}</a>
        </Col>
      );
      formatedData.push({
        key: formflow.id,
        id: formflow.id,
        name: formflow.name || "-",
        version: formflow.version || "-",
        createdAt: formflow.createdAt || "-",
        units: formflow.units,
        linkUnits: linkUnitInfo,
        langs: formflow.langs ? formflow.langs : []
      })
    })

    return formatedData;
  }

  async onSubmit() {
    this.setState({ loadingRequest: true })
    try {
      this.setState({ loadingRequest: false })
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l('common.error'), e);
      this.setState({ loadingRequest: false })
    }
  }

  async deleteFormflow(id: string) {
    try {
      const { tableData } = this.state;
      await _formflowService.deleteById(id, this.idUnit);

      const nextTableData = tableData.filter((item: IProcess) => item.id !== id);
      this.setState({
        isLoading: false,
        tableData: nextTableData,
      });
      await NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("process.deleteProcess"));
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), e);
    }
  }

  loadMoreFormflows() {
    this.setState({ loadingMoreFormflows: true });
    this.getFormflows(false, false);
  }

  onEditFormflow(item: IProcess) {
    this.setState({ openFormflowRegister: item.id })
  }


  readS3File = async (keyString: string) => {
    const storage = JSON.parse(localStorage.getItem('clientUpload') || '');
    const userAccessKey = await this._userService.getAccessAWS('s3');

    AWS.config.update({
      accessKeyId: userAccessKey.AccessKeyId,
      secretAccessKey: userAccessKey.SecretAccessKey,
      sessionToken: userAccessKey.SessionToken,
      region: storage.region
    });

    const s3 = new S3()

    const parms = {
      Bucket: storage.bucket,
      Key: keyString[1]
    };

    const data = await s3.getObject(parms).promise();
    return JSON.parse(data.Body ? data.Body.toString() : '')
  }

  onTranslateProcess = async (item: IProcess, i: number) => {
    let en: boolean = false;
    let pt: boolean = false;
    let es: boolean = false;

    this.setState({
      toggleTranslate: true,
      idProcessTranslate: item.id ? item.id : '',
      loadLangs: true
    })

    const langDefault = item.langs.find((item: any) =>
      item.id === 'default'
    );

    let keyString = langDefault.url.split('io/')
    let keyStringPt = ''
    let keyStringEn = ''
    let keyStringEs = ''

    for (let lang of item.langs) {
      if (lang.id === 'pt-BR') {
        keyStringPt = lang.url.split('io/')
        pt = true
      }
      if (lang.id === 'en') {
        keyStringEn = lang.url.split('io/')
        en = true
      }
      if (lang.id === 'es') {
        keyStringEs = lang.url.split('io/')
        es = true
      }
    }

    if (pt) {
      const dataPT = await this.readS3File(keyStringPt)
      this.setState({
        dataPT
      })
    }
    if (en) {
      const dataEn = await this.readS3File(keyStringEn)
      this.setState({
        dataEn
      })
    }
    if (es) {
      const dataEs = await this.readS3File(keyStringEs)
      this.setState({
        dataEs
      })
    }
    const data = await this.readS3File(keyString)
    this.setState({
      dataTranslate: data,
    })
    this.setState({ loadLangs: false })
  }

  submitFormTranslate = async (e: any) => {
    e.preventDefault();
    this.setState({ saveLoadLangs: true })
    const data = {};
    data['help'] = ''
    for (const field in this.refs) {
      data[`${field}`] = e.target.elements[`${this.state.saveLang}-${field}`].value != undefined ? e.target.elements[`${this.state.saveLang}-${field}`].value : "";
    }
    if (this.state.saveLang) {
      try {
        const res = await _formflowService.langAdd(
          this.state.idProcessTranslate,
          this.state.saveLang,
          this.idUnit,
          data);
        if (res.url) {
          const s3File = res.url.split('io/')
          const dataLanguage = await this.readS3File(s3File)

          if (this.state.saveLang === 'pt-BR') {
            this.setState({
              dataPT: dataLanguage
            })
          }
          if (this.state.saveLang === 'en') {
            this.setState({
              dataEn: dataLanguage
            })
          }
          if (this.state.saveLang === 'es') {
            this.setState({
              dataEs: dataLanguage
            })
          }
        }

        const process = this.state.tableData;

        const processKey = process.findIndex((x: any) => x.id === this.state.idProcessTranslate)
        const langs = process[processKey].langs;

        langs.map((e: any) => {
          if (e.id === this.state.saveLang) {
            e.url = res.url
          }
        })

        await NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("common.notification.translateSuccess"));

        this.setState({ saveLoadLangs: false })
      } catch (error) {
        await NotificationComponent.Notify('error', I18n.l("common.error"), error);
        this.setState({ saveLoadLangs: false })
      }
    }

  }

  handleInputPtChange = (idx: any, key: string) => async (evt: any) => {

    const data = Object.entries(this.state.dataTranslate)
    const newPT = Object.assign(data);
    newPT[idx] = [key, evt.target.value]
    this.setState({ dataPT: newPT });
  }

  handleInputEnChange = (idx: any, key: string) => async (evt: any) => {
    const data = this.state.dataEn.length > 0 ? this.state.dataEn : this.state.dataTranslate

    const newEn = Object.assign(data);
    newEn[idx] = [key, evt.target.value]
    this.setState({ dataEn: newEn });

  }
  handleInputEsChange = (idx: any, key: string) => async (evt: any) => {
    const data = this.state.dataEs.length > 0 ? this.state.dataEs : this.state.dataTranslate

    const newEs = Object.assign(data);
    newEs[idx] = [key, evt.target.value]
    this.setState({ dataEs: newEs });

  }

  showFormTranslate() {
    let inputs: JSX.Element[] = []
    const data = this.state.dataTranslate
    const dataPt = this.state.dataPT
    const dataEn = this.state.dataEn
    const dataEs = this.state.dataEs

    for (let key in data) {
      inputs.push(
        <Row style={{ paddingBottom: '1rem' }} key={`row-pt-${key}`}>
          <Col sm={8} md={8} xl={8} key={`col-${key}`}>
            <div style={{ fontSize: '15px', fontWeight: 'bold' }}>
              {key}
            </div>
            <div style={{ color: `${Theme.secondary.grey}`, fontWeight: 'bold' }}>
              {data[`${key}`] !== "" ? data[`${key}`] : "--"}
            </div>
          </Col>
          <Col style={{ paddingRight: '1rem' }} sm={4} md={4} xl={4}>
            <TextArea ref={`${key}`} name={`pt-BR-${key}`} key={`pt-BR-${key}`} defaultValue={dataPt[`${key}`] ? dataPt[`${key}`] : data[`${key}`]} />
          </Col>
          <Col style={{ paddingRight: '1rem' }} sm={4} md={4} xl={4}>
            <TextArea ref={`${key}`} name={`en-${key}`} key={`en-${key}`} defaultValue={dataEn[`${key}`] ? dataEn[`${key}`] : data[`${key}`]} />
          </Col>
          <Col style={{ paddingRight: '1rem' }} sm={4} md={4} xl={4}>
            <TextArea ref={`${key}`} name={`es-${key}`} key={`es-${key}`} defaultValue={dataEs[`${key}`] ? dataEs[`${key}`] : data[`${key}`]} />
          </Col>

        </Row>
      )
    }
    return inputs;
  }

  getInputsPt() {
    let inputsPt: JSX.Element[] = []
    const dataPt = Object.entries(this.state.dataPT)
    const data = Object.entries(this.state.dataTranslate)
    if (dataPt.length > 0) {
      for (let [index, labels] of dataPt.entries()) {
        inputsPt.push(
          <Row style={{ paddingBottom: '1.2rem' }}>
            <Input defaultValue={labels[1].toString() || ''} onChange={this.handleInputPtChange(index, labels[0])} />
          </Row>
        )
      }
    }
    else {
      for (let [index, labels] of data.entries()) {
        inputsPt.push(
          <Row style={{ paddingBottom: '1.2rem' }}>
            <Input onChange={this.handleInputPtChange(index, labels[0])} />
          </Row>
        )
      }
    }

    return inputsPt;
  }

  getInputsEn() {
    let inputsEn: JSX.Element[] = []
    const dataEn = Object.entries(this.state.dataEn)
    const data = Object.entries(this.state.dataTranslate)
    if (dataEn.length > 0) {
      for (let [index, labels] of dataEn.entries()) {
        inputsEn.push(
          <Row style={{ paddingBottom: '1.2rem' }}>
            <Input defaultValue={labels[1].toString() || ''} onChange={this.handleInputEnChange(index, labels[0])} />
          </Row>
        )
      }
    }
    else {
      for (let [index, labels] of data.entries()) {
        inputsEn.push(
          <Row style={{ paddingBottom: '1.2rem' }}>
            <Input onChange={this.handleInputEnChange(index, labels[0])} />
          </Row>
        )
      }
    }
    return inputsEn;
  }

  getInputsEs() {
    let inputsEs: JSX.Element[] = []
    const dataEs = Object.entries(this.state.dataEs)
    const data = Object.entries(this.state.dataTranslate)
    if (dataEs.length > 0) {
      for (let [index, labels] of dataEs.entries()) {
        inputsEs.push(
          <Row style={{ paddingBottom: '1.2rem' }}>
            <Input defaultValue={labels[1].toString() || ''} onChange={this.handleInputEsChange(index, labels[0])} />
          </Row>
        )
      }
    }
    else {
      for (let [index, labels] of data.entries()) {
        inputsEs.push(
          <Row style={{ paddingBottom: '1.2rem' }}>
            <Input onChange={this.handleInputEsChange(index, labels[0])} />
          </Row>
        )
      }
    }
    return inputsEs;
  }

  searchFormflows = async (event: any) => {
    event.preventDefault();
    await this.setState({
      search: event.target.find.value,
      isLoading: true
    })
    if (event === '') {
      await this.setState({
        search: ''
      })
    }
    await this.setState({
      isLoading: true,
    })
    this.getFormflows(true, true);
  }

  //#region UNIT SELECTION MODAL

  async toggleUnitSelectModal(processId?: string) {
    this.setState({ selectedProcessId: processId || '' })

    await this.updateSelectedProcessObject();
    if (processId) this.getProcessUnitsIds(processId);

    this.setState({
      showUnitSelectModal: !this.state.showUnitSelectModal,
    });
  }

  async updateSelectedProcessObject() {
    const { selectedProcessId, tableData } = this.state;
    let selectedProcess = undefined;
    selectedProcess = await tableData.find((item: any) => item.id === selectedProcessId);
    this.setState({ selectedProcessObject: selectedProcess });
  }

  async getProcessUnitsIds(processId: string) {
    this.setState({ unitsAlreadySaved: [] });
    const { tableData } = this.state;

    if (tableData === undefined || tableData.length === 0) {
      return;
    }
    const process = tableData.filter((item: any) => item.id == processId);
    const newUnitsSavedData: string[] = process[0].units || [];


    this.setState({ unitsAlreadySaved: newUnitsSavedData });
  }

  async onRemoveUnit(id: string) {
    const { selectedProcessId } = this.state;
    await this.setLoadingUnitData(id, true);

    if (selectedProcessId == undefined) {
      this.setLoadingUnitData(id, false);
      return;
    }
    try {
      await _formflowService.unitRemove(selectedProcessId, id, this.idUnit);
      this.unitRemoved(id);
      this.setLoadingUnitData(id, false);
    } catch (e) {
      this.setLoadingUnitData(id, false);
      NotificationComponent.NotifyWithMoreDuration('error', I18n.l('common.error'), e);
    }
  }

  async onAddUnit(id: string) {
    const { selectedProcessId } = this.state;
    this.setLoadingUnitData(id, true);

    if (selectedProcessId == undefined) {
      this.setLoadingUnitData(id, false);
      return;
    }

    try {
      await _formflowService.unitAdd(selectedProcessId, id, this.idUnit);
      this.unitAdded(id);
      this.setLoadingUnitData(id, false);
    } catch (e) {
      this.setLoadingUnitData(id, false);
      NotificationComponent.NotifyWithMoreDuration('error', I18n.l('common.error'), e);
    }
  }

  async unitAdded(id: string) {
    const { unitsAlreadySaved } = this.state;

    const newAlreadySaved: any[] = [...unitsAlreadySaved];
    newAlreadySaved.push(id);

    this.setState({ unitsAlreadySaved: newAlreadySaved });
    this.setUnitsToUser();
  }

  async unitRemoved(id: string) {
    const { unitsAlreadySaved } = this.state;

    const newAlreadySaved: any[] = [...unitsAlreadySaved];
    const index = newAlreadySaved.indexOf(id);
    newAlreadySaved.splice(index, 1);
    this.setState({ unitsAlreadySaved: newAlreadySaved });
    this.setUnitsToUser();
  }

  setUnitsToUser() {
    const { tableData, selectedProcessId, unitsAlreadySaved } = this.state;

    if (tableData != undefined) {
      const person = tableData.filter((item: any) => item.id == selectedProcessId);
      const index = tableData.indexOf(person[0]);
      const unitsIds: string[] = [];

      unitsAlreadySaved.map((unit: any) => {
        unitsIds.push(unit.id);
      })

      let formattedTableData: any = [...tableData];
      if (formattedTableData[index] != undefined) {
        formattedTableData[index].units = unitsAlreadySaved;
      }

      const newTableData = this.formatDataToTable(formattedTableData);

      this.setState({ tableData: newTableData });
    }
  }

  setLoadingUnitData = async (auditId: string, loading: boolean) => {
    const { unitsData } = this.state;

    const unit: any = unitsData.find((item) => {
      return item.id == auditId;
    });
    const indexOf = unitsData.indexOf(unit);

    const newUnitsData: any[] = [...unitsData];
    newUnitsData[indexOf].loading = loading;

    this.setState({ unitsData: newUnitsData });
  }

  getUnitSelectModalTitle() {
    const { selectedProcessObject } = this.state;
    if (!!selectedProcessObject) {
      return I18n.l('audits.titles.processWhatUnitWithName').replace("{name}", selectedProcessObject.name);
    }
    return I18n.l('audits.titles.processWhatUnit');
  }

  //#endregion

  onClickBack = async () => {
    this.setState({
      toggleTranslate: false,
      dataTranslate: [],
      dataPT: [],
      dataEn: [],
      dataEs: []
    })
  }

  onOnboardingSeen = async (hasSeenOnboardingResponse: any) => {
    this.setState({ hasSeenOnboarding: JSON.parse(hasSeenOnboardingResponse) })
  }

  async onDuplicate(item: any) {
    try {
      this.setState({ isDuplicating: true })
      const process = await this._processService.getById<IProcess>(item.id, this.idUnit)
      const copy: any = {}

      copy.name = process.name + ' (copy)'
      copy.sections = process.sections
      copy.version = 1
      copy.units = process.units
      copy.pillar = process.pillar
      copy.groupId = process.groupId

      await this._processService.create(copy, this.idUnit)
      this.setState({ isDuplicating: false })

      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("process.saveSucessfully"))

      this.setState({ isLoading: true })
      this.getUnits(true)
      this.onboardingSawValidator()
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), e)
      this.setState({ isDuplicating: false })
    }
  }

  render() {
    const {
      isLoading,
      search,
      tableData,
      filteredTableData,
      offset,
      loadingMoreFormflows,
      serverResponse,
      showUnitSelectModal,
      unitsAlreadySaved,
      unitsData
    } = this.state;

    if (this.state.openFormflowRegister != undefined) {
      this.setState({ openFormflowRegister: undefined })
      return (<Redirect
        push
        to={this.currentPillar !== 'LI' ? `${Routes.componentFormflow}/${this.state.openFormflowRegister}` : `${Routes.process}/${this.state.openFormflowRegister}`}
        from={Routes.formflowProcess}
        strict
      />
      )
    }

    if (isLoading) {
      return (
        <PageWithoutTitle>
          <div style={{ paddingBottom: '3rem' }}>
            <span style={{ color: 'black', fontSize: '48px', fontWeight: 'bold', paddingBottom: '3rem' }} >
              {this.currentPillar === 'EHSS' && I18n.l('routes.formflowProcess')} {this.currentPillar !== 'EHSS' && I18n.l('labels.processTitle')}
            </span>
          </div>
          <div>
            <span>{I18n.l('common.loadingTable')}</span>
          </div>
        </PageWithoutTitle>
      );
    }

    return (
      <PageWithoutTitle>
        <div style={this.state.toggleTranslate ? { display: 'none' } : {}}>
          <span style={{ color: 'black', fontSize: '48px', fontWeight: 'bold', paddingBottom: '3rem' }} >
            {this.currentPillar === 'EHSS' && I18n.l('routes.formflowProcess')} {this.currentPillar !== 'EHSS' && I18n.l('labels.processTitle')}
          </span>
          <Wrapper>
            {this.state.hasSeenOnboarding &&
              <Toolbar>
                <ToolbarItem>
                  <RegisterBtnComponent
                    onClick={this.registerFormflow}
                    buttonText={this.currentPillar === 'LI' ? I18n.l('common.register') + " " + I18n.l('labels.processTitle') : I18n.l('common.register') + " " + I18n.l('labels.formflowProcess')}
                  />
                </ToolbarItem>
                <ToolbarItem>
                  <SearchComponent
                    onSubmit={this.searchFormflows}
                    placeholder='form.placeholders.formflowSearch'
                    defaultValue={search}
                    buttonText='form.buttons.search'
                  />
                </ToolbarItem>
              </Toolbar>
            }

            {this.state.hasSeenOnboarding !== true &&
              <LiteOnboarding onOnboardingSeen={this.onOnboardingSeen} />
            }
            {tableData.length > 0 && (
              <React.Fragment>


                {this.state.hasSeenOnboarding &&
                  <div className={'goepik-component-tablesize'}>
                    <Table
                      columns={tableColumns}
                      data={filteredTableData.length > 0 ? filteredTableData : tableData}
                      onEdit={this.onEditFormflow}
                      onTranslate={this.onTranslateProcess}
                      onDelete={this.deleteFormflow}
                      noPagination={true}
                      showConfirmationModal={false}
                      labelDelete={I18n.l('process.deleteButton')}
                      descriptionDelete={I18n.l('process.deleteDescription')}
                      onDuplicate={this.onDuplicate}
                      isDuplicating={this.state.isDuplicating}
                    />
                  </div>
                }

                {offset && this.state.hasSeenOnboarding && (
                  <Button
                    className="loading-more"
                    type="primary"
                    size='large'
                    ghost
                    loading={loadingMoreFormflows}
                    onClick={this.loadMoreFormflows}>{I18n.l('common.seeMore')}</Button>
                )}
              </React.Fragment>
            )}

            {tableData.length === 0 && this.state.hasSeenOnboarding && <p>{I18n.l('common.noResult')}</p>}

            {showUnitSelectModal && this.state.hasSeenOnboarding && (
              <SelectableDataComponent
                title={this.getUnitSelectModalTitle()}
                data={unitsData}
                showModal={showUnitSelectModal}
                loadingData={false}
                auditorAuditsIds={unitsAlreadySaved}
                onItemRemoved={this.onRemoveUnit}
                onItemSelected={this.onAddUnit}
                serverResponse={serverResponse}
                onToggleFormModal={() => this.toggleUnitSelectModal()}

                savedDefaultValues={this.state.actualUnit ? [this.state.actualUnit.name] : undefined}
                customNoSavedItemsString={I18n.l('process.titles.noUnitsSaved')}
                customNoItemsToSaveString={I18n.l('process.titles.noUnitsToSave')}
                customNoInfoString={I18n.l('process.titles.noUnitsRegistered')}
                customWhereCreateItemsInfoString={I18n.l('process.titles.whereAddUnitInfo')}
              />
            )}
          </Wrapper>
        </div>
        {this.state.loadLangs && this.state.hasSeenOnboarding &&
          <p>{I18n.l('common.loadingData')}</p>
        }
        {!this.state.loadLangs && this.state.hasSeenOnboarding &&
          <div style={!this.state.toggleTranslate ? { display: 'none' } : {}} >
            <Row>
              <span style={{ color: 'black', fontSize: '48px', fontWeight: 'bold', paddingBottom: '1rem' }} >{I18n.l('history.detailTitle')}</span>
              <Button
                type='primary'
                style={{ float: 'right', marginTop: '16px' }}
                onClick={this.onClickBack}
              >
                {I18n.l('common.back')}
              </Button>
            </Row>

            <Row style={{ fontWeight: 'bold', paddingBottom: '2rem' }} >
              <Col sm={8} md={8} xl={8}>
              </Col>
              <Col style={{ paddingRight: '1rem', textAlign: 'center' }} sm={4} md={4} xl={4}>
                {I18n.l('common.translate.pt')}
              </Col>
              <Col style={{ paddingRight: '1rem', textAlign: 'center' }} sm={4} md={4} xl={4}>
                {I18n.l('common.translate.en')}
              </Col>
              <Col style={{ textAlign: 'center' }} sm={4} md={4} xl={4}>
                {I18n.l('common.translate.es')}
              </Col>
            </Row>
            <form onSubmit={(values) => {
              this.submitFormTranslate(values);
            }}>
              <Row>
                <Col>{this.showFormTranslate()}</Col>
              </Row>
              <Row style={{ fontWeight: 'bold', paddingBottom: '2rem' }}>
                <Col sm={8} md={8} xl={8}></Col>
                <Col style={{ paddingRight: '1rem', textAlign: 'center' }} sm={4} md={4} xl={4}>
                  <Button disabled={this.state.saveLoadLangs} type='primary' htmlType='submit' onClick={() => this.setState({ saveLang: 'pt-BR' })}>Salvar</Button>
                </Col>
                <Col style={{ paddingRight: '1rem', textAlign: 'center' }} sm={4} md={4} xl={4}>
                  <Button disabled={this.state.saveLoadLangs} type='primary' htmlType='submit' onClick={() => this.setState({ saveLang: 'en' })}>Salvar</Button>
                </Col>
                <Col style={{ textAlign: 'center' }} sm={4} md={4} xl={4}>
                  <Button disabled={this.state.saveLoadLangs} type='primary' htmlType='submit' onClick={() => this.setState({ saveLang: 'es' })}>Salvar</Button>
                </Col>
              </Row>
            </form>
          </div>
        }
      </PageWithoutTitle >
    );
  }
}


const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
`;

const Toolbar = styled.div`
  flex: 0;
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 40px;
  width: 100%;
  padding-top: 3rem;
`;

const ToolbarItem = styled.div`
  flex: 1;
  margin-left: 50px;

  &:first-of-type {
    flex: 0;
    margin-left: 0;
  }
`;


